import React, { FC } from "react";
import triangle from "../../../../assets/triangle.svg";
import greyMagicEdenLogo from "../../../../assets/greyMagicEdenLogo.svg";
import "./ProposalTooltip.scss";

interface IProposalTooltip {
  tooltipTitle?: string;
  tooltipDescription: string;
  expandedDescription?: string;
  showIcon?: boolean;
  tootlipExternalLink?: string;
}

const ProposalTooltip: FC<{
  tooltipData: IProposalTooltip[];
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
}> = ({ tooltipData, handleMouseEnter, handleMouseLeave }) => {
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${
        tooltipData.length === 1
          ? "proposal-tooltip proposal-tooltip__single"
          : "proposal-tooltip"
      }`}
    >
      {tooltipData.length > 1 && (
        <img
          className="proposal-tooltip__left-triangle"
          src={triangle}
          alt="triangle"
        />
      )}
      <div className="proposal-tooltip__content">
        <div className="proposal-tooltip__info">
          {tooltipData.map((item, index) => {
            return (
              <div
                className="proposal-tooltip__tooltip-wrapper"
                key={item.tooltipTitle}
              >
                <div className="proposal-tooltip__tooltip-item">
                  {item.tooltipTitle && (
                    <div className="proposal-tooltip__tooltip-title">
                      <p>{item.tooltipTitle}</p>
                      {item.showIcon && (
                        <img src={greyMagicEdenLogo} alt="magicEdenIcon" />
                      )}
                    </div>
                  )}
                  <p className="proposal-tooltip__tooltip-description">
                    {item.tooltipDescription}
                  </p>
                  {item.expandedDescription && (
                    <p className="proposal-tooltip__tooltip-description">
                      {item.expandedDescription}
                    </p>
                  )}
                  {item.tootlipExternalLink && (
                    <p className="proposal-tooltip__link">
                      Read more on our{" "}
                      <a
                        href={item.tootlipExternalLink}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Gitbook
                      </a>
                    </p>
                  )}
                </div>
                {tooltipData.length > 1 && index === 0 && (
                  <div className="proposal-tooltip__horizontal-line"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {tooltipData.length === 1 && <img src={triangle} alt="triangle" />}
    </div>
  );
};

export default ProposalTooltip;
